(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrCaseImportController', TrCaseImportController)
    .directive("fileread", [function () {
    	'use strict';

        return {
            restrict: "A",

            link: function($scope, element){

                element.change(function(event){
                    $scope.$apply(function(){
                      $scope.myFile =element[0].files[0];
                      
                    });
                });
            }

        };
}]);

    TrCaseImportController.$inject = ['$timeout', '$scope','TrCaseUploadNew'];

    function TrCaseImportController ($timeout, $scope, TrCaseUploadNew) {
        var vm = this;

        vm.upload= upload;
        
		 var formData;
	        // function upload(){
	        // 	formData=new FormData();
	        // 	formData.append('file',$scope.myFile);
	        
	        // 	TrCaseUploadNew.trcaseupload(formData,function(response,headers){
	        // 		if(response.status == 200){
	        //      		vm.error=null;
	        //      		vm.success='OK';
	             		
	        //     		$timeout(function(){
	        //     			vm.success= '';
	        //     		},4000);
	            		
	            		
	        //      	} 
	        //      	if(response.status == 400){
	        //      		vm.success=null;
	        //      		vm.error='error';
	             			
	        //      	} 
	        //      });
	        	
	        // }

		function upload() {
			formData = new FormData();
			formData.append('file', $scope.myFile);

			TrCaseUploadNew.trcaseupload(formData, function (response, headers) {
				if (response.status === 200) {
					vm.error = null;
					vm.success = 'OK';

					// ✅ create blob from response
					var blob = new Blob([response.data], {
						type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					});

					// ✅ get filename from header (backend sets: Content-Disposition: attachment; filename=import_results.xlsx)
					var contentDisposition = headers('content-disposition');
					var filename = "import_results.xlsx";
					if (contentDisposition) {
						var match = contentDisposition.match(/filename="?(.+)"?/);
						if (match.length > 1) {
							filename = match[1];
						}
					}

					// ✅ trigger download
					var link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = filename;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);

					$timeout(function () {
						vm.success = '';
					}, 4000);

				} else if (response.status === 400) {
					vm.success = null;
					vm.error = 'error';
				}
			});
		}
			$(":file").filestyle({buttonBefore: true});      
			$(":file").filestyle('buttonText', 'Browse File');
		

    }
})();
